module.exports = __webpack_public_path__ + "img/fangjia.3e329a60.jpg";